export default __webpack_public_path__ + "static/media/footer-bg-xl.cad51b0b.png";